export default "__VITE_ASSET__f$OSfvuB__"